import { useEffect, useState } from "react";
import { API_URL } from "@/lib/api";

/** Admin-managed reviews. Only authentic, permission-confirmed reviews are published — none means this stays hidden. */
export default function ReviewsSection() {
  const [reviews, setReviews] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API_URL}/reviews`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive) setReviews((d && d.reviews) || []);
      })
      .catch(() => alive && setReviews([]));
    return () => {
      alive = false;
    };
  }, []);

  if (!reviews || !reviews.length) return null;
  return (
    <section className="section" style={{ paddingTop: 40 }} id="reviews">
      <div className="wrap">
        <span className="eyebrow">IN CUSTOMERS' WORDS</span>
        <h2 style={{ margin: "12px 0 24px", fontSize: "clamp(28px,3vw,40px)" }}>Approved reviews, nothing invented.</h2>
        <div className="cards-grid" data-testid="reviews-grid">
          {reviews.map((r, i) => (
            <blockquote key={i} className="service-card" style={{ fontStyle: "normal", height: "100%" }}>
              <p style={{ fontSize: 14 }}>“{r.quote}”</p>
              <p style={{ marginTop: "auto", paddingTop: 12 }}>
                <b>{r.author}</b>
                {r.role ? <span> · {r.role}</span> : null}
              </p>
              {r.originalUrl ? (
                <a className="go" href={r.originalUrl} target="_blank" rel="noreferrer">
                  Original review ↗
                </a>
              ) : null}
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
